<template>
  <div class="footerHome">
    <div class="footerHomeDiv">
      <span>主管部门:</span> <span>濮阳市农业农村局</span>
    </div>

    <div class="line">|</div>

    <div class="footerHomeDiv">
      <span>监督部门:</span> <span>濮阳市纪委监委</span>
    </div>

    <div class="line">|</div>

    <div class="footerHomeDiv">
      <span>管理单位:</span>
      <span>濮阳市农村集体"三资"服务办公室</span>
    </div>

    <div class="line">|</div>

    <div class="footerHomeDiv">
      <span>技术单位:</span>
      <span>河南晟宇信息技术有限公司</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
}
</script>

<style scoped>
.footerHome {
  width: 100%;
  height: 44px;
  /* background: rgba(0, 0, 0, 0.4); */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: #e0e0e0;

  color: #fff3e0;
  font-family: Source Han Sans;
  opacity: 1;
  font-size: 16px;
  font-weight: normal;
}
.footerHomeDiv {
  padding: 0 44px;
  color: #363636;
}
.line {
  color: rgba(0, 0, 0, 0.2);
}
span:first-child {
  margin-right: 8px;
}
</style>
